module.exports = __webpack_public_path__ + "static/img/047.42c73083.png";